import * as loadQueueHelper from '../../../js/document/load-queue'
import Calendar from './main'

loadQueueHelper.add(function () {
  Calendar.createInstancesOnDocument()
})
